import { Link, useNavigate } from 'react-router-dom';
import { API_BASE_URL, ENDPOINTS } from '../../config';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import 'notyf/notyf.min.css';
import { Notyf } from 'notyf';
import MainHeader from '../Sidebar/MainHeader';

const notyf = new Notyf({
  position: {
    x: 'right',
    y: 'top'
  },
  ripple: true,
  dismissible: true,
});
const NewChat = () => {
  const navigate = useNavigate();
  const [cookies] = useCookies(['token']);
  const templates = [
    { title: "Brainstorm Ideas", icon: "fa-lightbulb", color: "#19c37d" },
    { title: "Technical Support", icon: "fa-life-ring", color: "#3b82f6" },
    { title: "Creative Writing", icon: "fa-pen-nib", color: "#f59e0b" },
    { title: "Data Analysis", icon: "fa-chart-bar", color: "#8b5cf6" },
  ];
  const startNewChat = async (title) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}${ENDPOINTS.CHATS.CREATE}`,
        { title: title ,messages:[{content:'',sender:''}]},
        { headers: { Authorization: `Bearer ${cookies.token}` } }
      );
      navigate(`/c/${response.data.chat_id}`);
    } catch (err) {
      notyf.error('Failed to create new chat');
    }
  };
  return (
    <>
    <main class="main-content">
      <MainHeader></MainHeader>
      <div class="container-fluid py-4 px-4">
        <h4>Start New Chat</h4>
        <p>Choose a template or start from scratch</p>
        <div class="models-container">
          <div className="row g-4">
            {templates.map((template, index) => (
              <div 
                key={index} 
                className="col-lg-3 col-md-6 model-item" 
                data-category={template.category}
              >
                <div 
                  className="model-card" 
                  style={{ '--accent-color': template.color }}
                >
                  <div className="model-header">
                    <div className="model-icon">
                      <i className={`fas ${template.icon}`}></i>
                    </div>
                  </div>
                  <div className="model-body">
                    <h5 className="model-name">{template.title}</h5>
                  </div>
                  <div className="model-actions">
                    <button 
                      className="btn btn-xs btn-outline-primary" 
                      onClick={() => startNewChat(template.title)}
                    >
                      <i className="fas fa-arrow-right"></i> Start Chat
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>        
    </main>
    
  </>
  );
};

export default NewChat;